const message = {};
const oMessages = new Rx.BehaviorSubject(message);

function Alert() {

    const sendMessage = (type, args, params, timeout) => {

        oMessages.onNext({
            type,
            args,
            params,
            timeout,
        });

    };

    return {
        success(args, params, timeout) {

            sendMessage('success', args, params, timeout);

        },

        error(args, params, timeout) {

            sendMessage('error', args, params, timeout);

        },

        warning(args, params, timeout) {

            sendMessage('warning', args, params, timeout);

        },

        info(args, params, timeout) {

            sendMessage('info', args, params, timeout);

        },

        getObservable() {

            return oMessages;

        },
    };

}

export default Alert();



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/ui-alert/-RFC.ui-alert-logic.js